/**
 * @file
 * Behaviors for the Main Menu.
 */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Main Menu behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.mainMenu = {
    attach(context) {
      if (context !== document) {
        return;
      }

      const $menuDropToggle = $('.main-menu__toggle', context);

      $menuDropToggle.on('click', function() {
        const $thisToggle = $(this);
        const $toggleParent = $thisToggle.parent().parent();
        const $menuChild = $toggleParent.find('.list--1');

        $thisToggle.toggleClass('is-active');
        $menuChild.toggleClass('is-active');
      });
    }
  };
})(Drupal, jQuery);
